import React, { RefObject } from 'react';
import { Song } from '../types';

interface AudioPlayerProps {
  currentSong: Song | null;
  nextSong: Song | null;
  currentAudioRef: RefObject<HTMLAudioElement>;
  nextAudioRef: RefObject<HTMLAudioElement>;
  onAudioEnded: () => void;
}

const AudioPlayer: React.FC<AudioPlayerProps> = ({
  currentSong,
  nextSong,
  currentAudioRef,
  nextAudioRef,
  onAudioEnded
}) => {
  return (
    <>
      {/* Current Audio Player */}
      {currentSong && (
        <audio 
          ref={currentAudioRef}
          src={currentSong.downloadUrl}
          loop={false}
          onEnded={onAudioEnded}
          preload="auto"
          onLoadStart={() => console.log("Loading started for current song:", currentSong.title)}
          onCanPlay={() => console.log("Current song can play:", currentSong.title)}
        />
      )}
      
      {/* Next Audio Player (for fading) */}
      {nextSong && (
        <audio 
          ref={nextAudioRef}
          src={nextSong.downloadUrl}
          loop={false}
          preload="auto"
          onLoadStart={() => console.log("Loading started for next song:", nextSong.title)}
          onCanPlay={() => console.log("Next song can play:", nextSong.title)}
        />
      )}
    </>
  );
};

export default AudioPlayer; 